import { useCallback } from 'react';
import type { NavigateOptions, To } from 'react-router-dom';
import { useNavigate as useReactRouterNavigate } from 'react-router-dom';
import { useConfiguration } from '@/contexts/ConfigurationContext';

/**
 * Custom navigate hook that blocks navigation in preview mode
 * In preview mode, navigation is blocked - users can only view the current page
 */
export function usePreviewNavigate() {
  const navigate = useReactRouterNavigate();
  const { isPreviewMode, isDemoMode } = useConfiguration();

  return useCallback(
    (to: To, options?: NavigateOptions) => {
      // Block navigation in preview mode, but allow it in demo mode
      if (isPreviewMode && !isDemoMode) {
        // Navigation blocked in preview mode (but not demo mode)
        console.log('[usePreviewNavigate] Navigation blocked in preview mode', { to, isPreviewMode, isDemoMode });
        return;
      }
      // In non-preview mode or demo mode, navigate normally
      console.log('[usePreviewNavigate] Navigating to:', to);
      navigate(to, options);
    },
    [navigate, isPreviewMode, isDemoMode]
  );
}

